import axios from "axios";

const state = {
  aging: { buckets: [], grand_total: 0 },
  remarks: [],
};

const getters = {
  aging: (state) => state.aging,
  remarks: (state) => state.remarks,
};

const actions = {
  async get_ar_aging({ commit }) {
    const response = await axios.get("/invoices/ar_aging");
    commit("SET_AR_AGING", response.data);
  },

  async get_ar_remarks({ commit }, invoice_id) {
    const response = await axios.get(`/invoice/${invoice_id}/ar_remarks`);
    commit("SET_AR_REMARKS", response.data);
  },

  async add_ar_remark({ commit }, { invoice_id, remark }) {
    const response = await axios.post(`/invoice/${invoice_id}/ar_remarks`, {
      remark,
    });
    commit("PUSH_AR_REMARK", response.data);
    return response.data;
  },
};

const mutations = {
  SET_AR_AGING(state, aging) {
    state.aging = aging;
  },

  SET_AR_REMARKS(state, remarks) {
    state.remarks = remarks;
  },

  PUSH_AR_REMARK(state, remark) {
    state.remarks.push(remark);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
